import { makeActionCreator } from '../../../utilities'
import { CadImportConstants } from './cadImport.constants'

export const resetCadImportState = makeActionCreator(CadImportConstants.RESET_STATE)
export const setCadRecordsResponse = makeActionCreator(CadImportConstants.SET_CAD_RECORDS_RESPONSE, 'cadImport')
export const getCadRecords = makeActionCreator(CadImportConstants.GET_CAD_RECORDS)
export const preCadImport = makeActionCreator(CadImportConstants.PRE_CAD_IMPORT, 'importedCadData')
export const importCadData = makeActionCreator(CadImportConstants.IMPORT_CAD_DATA, 'importedCadData')
export const setSaveCadDataResponse = makeActionCreator(CadImportConstants.SET_SAVE_CAD_DATA_RESPONSE, 'importResponse')
export const setDisableUnitFilteringFlag = makeActionCreator(
  CadImportConstants.SET_DISABLE_UNIT_FILTERING_FLAG,
  'disableUnitFilteringFlag'
)
export const wipeCadData = makeActionCreator(CadImportConstants.WIPE_CAD_DATA)
export const setUserCanDisableUnitFilter = makeActionCreator(
  CadImportConstants.SET_USER_CAN_DISABLE_UNIT_FILTER,
  'userCanDisableUnitFilter'
)
export const setHasImportedCadData = makeActionCreator(CadImportConstants.HAS_IMPORTED_CAD_DATA, 'hasImportedCadData')
export const removeImportedCadDataPoint = makeActionCreator(
  CadImportConstants.REMOVE_IMPORTED_CAD_DATA_POINT,
  'dataPointId'
)
